import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';
import toast from 'react-hot-toast';

type Response =
  | {
      data: any;
    }
  | {
      error: FetchBaseQueryError | SerializedError;
    };

type MessageConfig = {
  loading: string;
  success: string;
  error: string;
};

export const useMutationStatusToast = (messageConfig: MessageConfig, toasterId = 'default') => {
  return (promise: Promise<Response>) => {
    const id = toast.loading(messageConfig.loading, { toasterId });
    const toastParams = {
      id,
      toasterId
    };

    promise
      .then(v => {
        if ('error' in v) {
          toast.error(messageConfig.error, toastParams);
        } else {
          toast.success(messageConfig.success, toastParams);
        }
      })
      .catch(() => toast.error(messageConfig.error, toastParams));
  };
};
